import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-cards.css';
import { UitkCardFeaturedHeaderTitleTags } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkCardFeaturedHeader = function (props) {
    var children = props.children, className = props.className, title = props.title, attributes = __rest(props, ["children", "className", "title"]);
    var baseClass = 'uitk-card-featured-header';
    var cssClassNames = getClassNameList(baseClass, 'uitk-card-roundcorner-top-right', 'uitk-card-roundcorner-top-left', className);
    var TitleTag = (title && title.tag) || UitkCardFeaturedHeaderTitleTags.get('p');
    return (React.createElement("header", __assign({ className: cssClassNames }, attributes),
        title && React.createElement(TitleTag, { className: getClassNameList('uitk-card-featured-header-title') }, title.text),
        children));
};
UitkCardFeaturedHeader.displayName = 'UitkCardFeaturedHeader';
// Temporary, unstable
var UitkCardAlohaFeaturedHeader = UitkCardFeaturedHeader;

export { UitkCardAlohaFeaturedHeader, UitkCardFeaturedHeader };
